export default __webpack_public_path__ + "static/media/thumb_HR_03.a0dedf42.jpeg";